import React, { useMemo, useCallback } from 'react';
import { Row, Col } from 'reactstrap';

const SignerCoordinatesConfigurationList = props => {
  const {
    signers,
    callbacks,
    currentSignerCustomId
  } = props;

  return (
    <Row>
      <Col>
        {_.map(signers, (signer, index) => {
          return (
            <SignerCoordinatesConfigurationItem
              key={`signer-${index}`}
              signer={signer}
              currentSignerCustomId={currentSignerCustomId}
              callbacks={callbacks}
            />
          )
        })}
      </Col>
    </Row>
  )
}

export default SignerCoordinatesConfigurationList;


const SignerCoordinatesConfigurationItem = props => {
  const {
    signer,
    currentSignerCustomId,
    callbacks: {
      onChangeCurrentSignerCustomerId: onChangeCurrentSignerCustomerIdCallback
    }
  } = props;

  const onChangeCurrentSignerCustomerId = useCallback((customId) => {
    onChangeCurrentSignerCustomerIdCallback(customId);
  }, [onChangeCurrentSignerCustomerIdCallback])

  const signerStyle = useMemo(() => {
    return {
      cursor: 'pointer',
      backgroundColor: signer.color
    }
  }, [signer])

  return (
    <div className="mb-2">
      <div
        className={`p-3 border rounded ${currentSignerCustomId === signer.custom_id ? 'border-primary bg-light' : ''}`}
        style={signerStyle}
        onClick={() => onChangeCurrentSignerCustomerId(signer.custom_id)}
      >
        <div className="row d-flex justify-content-start">
          <span className="fw-bold">{signer.order + 1} - {signer.email || I18n.t('no_entry')}</span>
          <div className='d-block'>
            <ul className='list-inline text-muted my-2 small'>
              <li className='list-inline-item'>
                {I18n.t('activerecord.attributes.signer.name')}: {signer.name || I18n.t('no_entry')}
              </li>
              <li className='list-inline-item'>
                {I18n.t('activerecord.attributes.signer.role')}: {signer.role || I18n.t('no_entry')}
              </li>
              <li className='list-inline-item'>
                Página de firma: {signer.sign_coordinates.page_number || I18n.t('no_entry')}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
